import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import projectsService from "./projectsService";

const initialState = {
  projects: [],
  search: [],
  project: null,
  isError: false,
  isSuccess: false,
  isLoading: false,
  isLoadingSearch: false,
  message: "",
};

// Add Projects
export const addProject = createAsyncThunk(
  "projects/addproject",
  async (projectData, thunkAPI) => {
    try {
      return await projectsService.addProject(projectData);
    } catch (error) {
      const message = error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get Projects
export const getProjects = createAsyncThunk(
  "projects/allprojects",
  async ({ page = 1, limit = 15 }, thunkAPI) => {
    try {
      return await projectsService.getProjects(page, limit);
    } catch (error) {
      const message = error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get Search Project
export const getSearchProjects = createAsyncThunk(
  "projects/search",
  async (inputValue, thunkAPI) => {
    try {
      return await projectsService.getSearchProjects(inputValue);
    } catch (error) {
      const message = error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get Project
export const getProject = createAsyncThunk(
  "projects/project",
  async (handle, thunkAPI) => {
    try {
      return await projectsService.getProject(handle);
    } catch (error) {
      const message = error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const projectsSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    RESET(state) {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.isLoadingSearch = false;
      state.message = "";
    },
    RESETSEARCH(state) {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.isLoadingSearch = false;
      state.message = "";
      state.search = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // Add Project
      .addCase(addProject.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(addProject.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(addProject.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // Get projects
      .addCase(getProjects.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getProjects.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.projects = action.payload;
      })
      .addCase(getProjects.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // Get search projects
      .addCase(getSearchProjects.pending, (state, action) => {
        state.isLoadingSearch = true;
      })
      .addCase(getSearchProjects.fulfilled, (state, action) => {
        state.isLoadingSearch = false;
        state.isSuccess = true;
        state.search = action.payload;
      })
      .addCase(getSearchProjects.rejected, (state, action) => {
        state.isLoadingSearch = false;
        state.isError = true;
        state.message = action.payload;
      })
      // Get project
      .addCase(getProject.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getProject.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.project = action.payload;
      })
      .addCase(getProject.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { RESET, RESETSEARCH } = projectsSlice.actions;

export default projectsSlice.reducer;
